<template>

  <v-list two-line>
    <v-subheader>Flight departure</v-subheader>

    <v-list-item v-if="value.calculatedTakeOffTime">
      <v-list-item-content>
        <v-list-item-title class="error--text font-weight-bold">
          Calculated take off time
        </v-list-item-title>
        <v-list-item-subtitle class="error--text font-weight-bold	">
          {{ value.calculatedTakeOffTime | localMoment('YYYY-MM-DD HH:mm') }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Scheduled</v-list-item-title>
        <v-list-item-subtitle>
          {{ value.scheduledTimeDeparture | localMoment('YYYY-MM-DD HH:mm') }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="estDep">
      <v-list-item-content>
        <v-list-item-title>Estimated</v-list-item-title>
        <v-list-item-subtitle>
          {{ estDep | localMoment('YYYY-MM-DD HH:mm') }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="actDep">
      <v-list-item-content>
        <v-list-item-title>Actual</v-list-item-title>
        <v-list-item-subtitle>
          {{ actDep | localMoment('YYYY-MM-DD HH:mm') }} <span class="error--text" v-if="value.actualDepApIata !== value.depApIata"> {{ value.actualDepApIata }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <!-- Duplicated parent component FlightInfoDeparture.vue that has the same data as FlightInfoArrival.vue -->
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Delay</v-list-item-title>
        <v-list-item-subtitle>
          <template v-if="value.delays && value.delays.length!==0">
            <li v-for="delay in value.delays">
              {{ delay }}
            </li>
          </template>
          <template v-else>
            -
          </template>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Stand</v-list-item-title>
        <v-list-item-subtitle>
          <template v-if="value.departureStand">
            {{ value.departureStand }}
          </template>
          <template v-else>
            -
          </template>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Gate</v-list-item-title>
        <v-list-item-subtitle>
          <template v-if="value.boardingGate">
            {{ value.boardingGate }}
          </template>
          <template v-else>
            -
          </template>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>

</template>

<script>
import { values } from 'lodash';


export default {
  name: 'FlightInfoDeparture',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ({
  }),
  components: {
  },
  methods: {
  },
  computed: {
    estDep() {
      return (this.value.scheduledTimeDeparture !== this.value.timeDeparture && !this.actDep) ? this.value.timeDeparture : undefined
    },
    actDep() {
      return this.value.offBlockTime
    },
  }
}
</script>
